var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 26,
    viewBox: "0 0 19 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50195 0C4.40628 0 0.15625 4.10475 0.15625 9.3457C0.15625 11.3396 0.755394 13.1175 1.90526 14.7835L8.78675 25.5215C9.12059 26.0435 9.884 26.0425 10.2172 25.5215L17.1285 14.747C18.2536 13.1565 18.8477 11.2889 18.8477 9.3457C18.8477 4.19248 14.6552 0 9.50195 0ZM9.50195 13.5938C7.15969 13.5938 5.25391 11.688 5.25391 9.3457C5.25391 7.00344 7.15969 5.09766 9.50195 5.09766C11.8442 5.09766 13.75 7.00344 13.75 9.3457C13.75 11.688 11.8442 13.5938 9.50195 13.5938Z",
    fill: "#E74C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.2b7a9199644c788ec7aa3e2b076e1664.svg";
export { ForwardRef as ReactComponent };